console.log('Custom JS d\'incrémentation chargé (universel B2B)');

function applyQtyIncrementLogic(qtyContainer) {
  if (qtyContainer.getAttribute('data-qty-init') === 'true') return;
  qtyContainer.setAttribute('data-qty-init', 'true');

  const qtyInput = qtyContainer.querySelector('input[type="number"]');
  const plusBtn = qtyContainer.querySelector('.qty-plus, [bss-b2b-btn-up-quantity]');
  const minusBtn = qtyContainer.querySelector('.qty-minus, [bss-b2b-btn-down-quantity]');
  if (!qtyInput || !plusBtn || !minusBtn) return;

  plusBtn.addEventListener('click', function(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    const increment = parseInt(qtyInput.getAttribute('data-increment'), 10) || parseInt(qtyInput.getAttribute('step'), 10) || 1;
    const min = parseInt(qtyInput.getAttribute('min'), 10) || increment;
    let current = parseInt(qtyInput.value, 10) || min;
    qtyInput.value = current + increment;
    qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
  });

  minusBtn.addEventListener('click', function(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    const increment = parseInt(qtyInput.getAttribute('data-increment'), 10) || parseInt(qtyInput.getAttribute('step'), 10) || 1;
    const min = parseInt(qtyInput.getAttribute('min'), 10) || increment;
    let current = parseInt(qtyInput.value, 10) || min;
    let next = current - increment;
    qtyInput.value = next < min ? min : next;
    qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
  });

  qtyInput.addEventListener('change', function() {
    const increment = parseInt(qtyInput.getAttribute('data-increment'), 10) || parseInt(qtyInput.getAttribute('step'), 10) || 1;
    let value = parseInt(qtyInput.value, 10) || increment;
    if (value % increment !== 0) {
      qtyInput.value = Math.ceil(value / increment) * increment;
    }
  });
}

function applyToAllQuantities() {
  document.querySelectorAll('.product-quantity, [bss-b2b-quantity-block], cart-product-quantity').forEach(applyQtyIncrementLogic);
}

applyToAllQuantities();

const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    mutation.addedNodes.forEach(function(node) {
      if (node.nodeType === 1) {
        if (
          (node.classList && node.classList.contains('product-quantity')) ||
          (node.hasAttribute && node.hasAttribute('bss-b2b-quantity-block')) ||
          node.tagName === 'CART-PRODUCT-QUANTITY'
        ) {
          applyQtyIncrementLogic(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('.product-quantity, [bss-b2b-quantity-block], cart-product-quantity').forEach(applyQtyIncrementLogic);
        }
      }
    });
  });
});
observer.observe(document.body, { childList: true, subtree: true });

document.addEventListener('bss-b2b-quantity-ready', applyToAllQuantities);